import { Element } from "@/scripts/extends";

export default class LoadMore extends Element {}
